export default {
  'primary': '#13abb1',
  'secondary': '#FF456D',
  'primary-variation-1': '#C5EAEB',
  'secondary-variation-1': '#FFEAEF',
  'primary-variation-2': '#F2FFFF',
  'accent': '#82B1FF',
  'error': '#EB2F06',
  'info': '#00D0BD',
  'success': '#13abb1',
  'warning': '#FFB70F',
  'danger': '#FF3739',
  'pink': '#FA0055',
  'blue': '#2E62FF',
  'purple': '#2B314A',
  'light': '#F5F5F5',
  'dark': '#000000',
  'base': '#FFFFFF',
  'base-light': '#FAFAFA',
  'gray-dark': '#464D69',
  'gray': '#727891',
  'gray-light': '#A5A7B2',
  'gray-lighter': '#DDE6F3',
  'border-color': '#EBEDF2',
  'card-bg': '#FFFFFF',
  'input-border-color': '#D7DCE4',
  'sidebar-bg-base': '#13abb1',
  'sidebar-nav-color': '#1D2433',
  'white': '#FFFFFF',
  'black': '#111111',
  'subtitle': '#828282',
  'disabled': '#B1B1B1'
}